export const enum ControlType {
    Radio = "radio",
    Select = "select",
    Autocomplete = "autocomplete",
    Textarea = "textarea"
}
